import React,{ useEffect} from 'react';
import 'leaflet/dist/leaflet.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { logout } from './Redux/currentUserSlice';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import Dashboard from './Pages/Dashboard';
import MeterDetails from './Pages/MeterDetail';
import Login from './Auth/Login';
import Account from './Pages/Account';
import MeterReport from './Components/Reports/MeterReport';
import MeterData from './Components/Meters/MeterData';
import Organization from './Components/Account/Organization';
import ProtectedRoute from './Components/ProtectedRoutes';
import Settings from './Components/Settings/Settings';
import ChangePassword from './Components/Settings/ChangePassword';
import OrgDetails from './Pages/OrganizationDetails'
import AdminDashboard from './Components/Admin/AdminDashboard'
import AdminMeterDetail from './Components/Admin/AdminMeterDetail';
import Home from './Landing/Home';
import About from './Landing/About';
import ContactUs from './Landing/ContactUs';
import Products from './Landing/Products';
import MeterLocations from './Components/Admin/MeterLocations';
import AddOrganization from './Components/Account/AddOrganization';
import AddMeter from './Components/Account/AddMeter';
import ConsumptionReport from './Components/Reports/ConsumptionReport';
import Portfolio from './Landing/Portfolio';
import AddUser from './Components/Meters/AddUser';
import AdminMpesaPayments from './Components/Admin/AdminMpesaPayments'
import CommandControl from './Components/Admin/CommandControl';
import AdminMeterData from './Components/Admin/AdminMeterData';
import CommandStatus from './Components/Admin/CommandStatus';
import OrganizationMpesaPayments from './Components/Organization.js/OrganizationMpesaPayments';
import AdminRegisterUrl  from './Components/Admin/AdminRegisterUrl';
import AdminAddMeter from './Components/Admin/AdminAddMeter';
import AdminBusinessPanel from './Components/Admin/AdminBusinessPanel';
import OrganizationMeterLocations from './Components/Organization.js/OrganizationMeterLocations';
import Logs from './Components/Admin/AdminUserLogs';
import Waterbalancereport from './Components/Reports/Waterbalancereport';

const App = () => {

  const dispatch = useDispatch();
  const token = useSelector((state) => state.currentUser?.token);

  // ✅ Check token validity on mount + every refresh
  useEffect(() => {
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      const isExpired = decoded.exp * 1000 < Date.now();

      if (isExpired) {
        dispatch(logout());
        window.location.href = '/login';
      }
    } catch (err) {
      console.warn('Invalid token:', err);
      dispatch(logout());
      window.location.href = '/login';
    }
  }, [token, dispatch]);

  return (
    <Router>
      <Routes>

        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/contactus' element={<ContactUs />} />
        <Route path='/products' element={<Products />} />
        <Route path='/portfolio' element={<Portfolio />} />
        <Route path='/login' element={<Login />} />
        <Route path='/settings' element={<Settings />} />
        <Route path='/account' element={<Account />} />
        <Route path='/dashboard' element={<Dashboard />} />

{/**Super Admin Access */}
<Route path='/user-logs' element={
          <ProtectedRoute requiredRole="super_admin">
            <Logs />
          </ProtectedRoute>} />
 <Route path='/business-panel' element={
          <ProtectedRoute requiredRole="super_admin">
            <AdminBusinessPanel />
          </ProtectedRoute>} />
 <Route path='/admin-add-meter' element={
          <ProtectedRoute requiredRole="super_admin">
            <AdminAddMeter />
          </ProtectedRoute>} />
 <Route path='/register-url' element={
          <ProtectedRoute requiredRole="super_admin">
            <AdminRegisterUrl />
          </ProtectedRoute>} />
        <Route path='/command-status' element={
          <ProtectedRoute requiredRole="super_admin">
            <CommandStatus />
          </ProtectedRoute>} />
        <Route path='/meter-report' element={
          <ProtectedRoute requiredRole="super_admin">
            <MeterReport />
          </ProtectedRoute>} />
        <Route path='/admin-meter-data' element={
          <ProtectedRoute requiredRole="super_admin">
            <AdminMeterData />
          </ProtectedRoute>} />

        <Route path='/meterData' element={
          <ProtectedRoute requiredRole={['super_admin', 'admin']}>
            <MeterData />
          </ProtectedRoute>} />

        <Route path='/organizations' element={
          <ProtectedRoute requiredRole="super_admin">
            <Organization />
          </ProtectedRoute>} />

        <Route path='/command-center' element={
          <ProtectedRoute requiredRole="super_admin">
            <CommandControl />
          </ProtectedRoute>} />

        <Route path='/payments' element={
          <ProtectedRoute requiredRole="super_admin">
            <AdminMpesaPayments />
          </ProtectedRoute>} />


        <Route path='/org-payments' element={
          <ProtectedRoute requiredRole="admin">
            <OrganizationMpesaPayments />
          </ProtectedRoute>} />


        <Route path='/waterbalance' element={
          <ProtectedRoute requiredRole={['super_admin', 'admin']}>
            <Waterbalancereport/>
          </ProtectedRoute>} />


    <Route path='/org-mapview' element={
          <ProtectedRoute requiredRole="admin">
            <OrganizationMeterLocations />
          </ProtectedRoute>} />

        <Route path='/admin-meter-details/:imei' element={
          <ProtectedRoute requiredRole='super_admin'>
            <AdminMeterDetail />
          </ProtectedRoute>} />

        <Route path="/meter-details/:imei" element={
          <ProtectedRoute requiredRole={['user', 'admin', 'super_admin']}>
            <MeterDetails />
          </ProtectedRoute>} />

        <Route path="/org-details/:uniqueKey" element={
          <ProtectedRoute requiredRole={['admin', 'super_admin']}>
            <OrgDetails />
          </ProtectedRoute>} />

        <Route path='/map' element={
          <ProtectedRoute requiredRole={['admin', 'super_admin']}>
            <MeterLocations />
          </ProtectedRoute>} />

        <Route path='/consumption-report' element={
          <ProtectedRoute requiredRole={['admin', 'super_admin']}>
            <ConsumptionReport />
          </ProtectedRoute>} />

        <Route path='/admin-dashboard' element={
          <ProtectedRoute requiredRole="super_admin">
            <AdminDashboard />
          </ProtectedRoute>} />

        <Route path='/add-organization' element={
          <ProtectedRoute requiredRole="super_admin">
            <AddOrganization />
          </ProtectedRoute>} />

        <Route path='/add-meter/:uniqueKey' element={
          <ProtectedRoute requiredRole="super_admin">
            <AddMeter />
          </ProtectedRoute>} />

        <Route path='/add-MeterUser/:meterId/:userPhoneNumber/:meterName' element={
          <ProtectedRoute requiredRole={["super_admin", "admin"]}>
            <AddUser />
          </ProtectedRoute>
        } />

        <Route path='/change-password' element={
          <ProtectedRoute requiredRole={['super_admin', 'admin', 'user']}>
            <ChangePassword/>
          </ProtectedRoute>
        }/>
      </Routes>

       <ToastContainer
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        pauseOnHover
        theme="colored"
      />
    </Router>
  );
}

export default App;